import type { ChatMessage } from './type';

export function shouldHideChatMessage(
  item: ChatMessage,
  messages: readonly ChatMessage[],
  isLast: boolean,
  isLoading: boolean
): boolean {
  if (item.messageType === 'tool_result') return true;

  if (item.messageType === 'tool_approval_request') {
    const approvalId = readApprovalId(item);
    if (!approvalId) return false;
    return !messages.some(
      message =>
        message.messageType === 'tool_approval_response' &&
        readApprovalId(message) === approvalId
    );
  }

  if (item.role !== 'assistant') return false;

  const hasContent = item.content.trim().length > 0;
  const hasStreamText = item.streamObjects?.some(
    object =>
      (object.type === 'text-delta' || object.type === 'reasoning') &&
      object.textDelta.trim().length > 0
  );
  const hasToolCards = item.streamObjects?.some(
    object => object.type === 'tool-call' || object.type === 'tool-result'
  );
  const hasEmbeddedToolResults = (item.toolData?.toolResults?.length ?? 0) > 0;

  return !(
    hasContent ||
    hasStreamText ||
    hasToolCards ||
    hasEmbeddedToolResults ||
    (isLast && isLoading)
  );
}

function readApprovalId(message: ChatMessage): string | null {
  const approvalId = message.toolData?.approvalId;
  return typeof approvalId === 'string' ? approvalId : null;
}
